import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDeleteCampaignMutation } from 'src/api/campaigns/hooks';
import { useGlobalModals } from 'src/contexts/global-modals';
import { links } from 'src/router/routes';

export const useDeleteCampaign = () => {
  const {
    deleteCampaignModal,
    closeDeleteCampaignModal,
    openLoadingModal,
    closeLoadingModal,
  } = useGlobalModals();
  const { deleteCampaignMutation, isPending } = useDeleteCampaignMutation();
  const navigate = useNavigate();

  const open = deleteCampaignModal.opened;
  const campaignId = deleteCampaignModal.campaignId;

  const handleConfirm = useCallback(async () => {
    if (!campaignId) {
      return;
    }

    openLoadingModal(
      'Deleting campaign',
      'Please wait while we delete the campaign...'
    );
    closeDeleteCampaignModal();

    try {
      await deleteCampaignMutation(campaignId);
      navigate(links.campaigns);
    } finally {
      closeLoadingModal();
    }
  }, [
    closeDeleteCampaignModal,
    closeLoadingModal,
    deleteCampaignMutation,
    campaignId,
    navigate,
    openLoadingModal,
  ]);

  const handleClose = useCallback(() => {
    closeDeleteCampaignModal();
  }, [closeDeleteCampaignModal]);

  return {
    handleClose,
    handleConfirm,
    isPending,
    open,
  };
};
